module.exports = __webpack_public_path__ + "img/1.77a6520c.jpg";